<template>
	<div>
		<ion-item lines="none"  class="ion-no-padding ion-no-margin ion-margin-vertical cmf-input-wrapper ion-text-left" >

			<ion-checkbox
				v-model="fieldData"
				:disabled="readonly"
				@ionChange="changed($event)">
			</ion-checkbox>
			<ion-label>
				<slot></slot>
			</ion-label>

			<div v-if="(v$ && v$[form][name].$dirty ) || (vBe && vBe[name])">
				<img v-if="!hasError" src="../_assets/img/check-input.svg" alt="">
				<img v-if="hasError" src="../_assets/img/x-input.svg" alt="">
			</div>
		</ion-item >
		<div class="error" v-if="v$ && v$[form][name].$invalid && v$[form][name].$dirty">
			<div v-for="(error, index) in v$[form][name].$errors" :key="index">
				{{validationErrors[error.$validator]}}
			</div>
		</div>

		<div class="error" v-if="vBe">
			<div v-for="(error, index) in vBe[name]"  :key="index">
				{{displayError(error)}}
			</div>
		</div>
	</div>
</template>

<script>
import utils from '@/plugins/w/toast/utils'

export default {
	emits: ['update:modelValue'],
	props: {
		modelValue: {
			type: Boolean,
			default: false
		},
		name: {
			required: true,
			default: ''
		},
		readonly: {
			type: Boolean,
			required: false,
			default: false
		},
		vBe: {
			type: Array,
			required: false,
		},
		form: {
			type: String,
			default: 'form'
		},
		v$: {
			default: null
		},
	},
	mounted() {
		this.fieldData = this.modelValue
	},
	watch: {
		modelValue(data) {
			this.fieldData = data
		}
	},
	computed: {
		hasError() {
			if ( this.vBe && this.vBe[this.name]) {
				return true
			} else if (this.v$ && this.v$[this.form][this.name].$dirty && this.v$[this.form][this.name].$invalid) {
				return true
			}

			return false
		}
	},
	data(){
		return{
			fieldData: false,
			validationErrors: {
				required: 'This field is mandatory.',
				mustBeTrue: 'You need to accept terms first.',
			}
		}
	},
	methods: {
		changed(e) {
			this.eventBus.emit('input', this.name)
			this.$emit('update:modelValue', e.target.checked)
		},
		displayError(error) {
			return utils.parseToString(error)
		}
	}
}
</script>

<style lang="sass" scoped>
.cmf-input-wrapper
  position: relative
  img
    position: absolute
    right: 10px
    bottom: 6px
    z-index: 20
  &.validation-enabled
    .custom-select
      background: #fff
ion-checkbox
  margin-right: 10px
  position: relative
  top: 6px
ion-item
  --background-hover: none
ion-label
  position: relative
  top: 6px
</style>
